fx.service( class FontLoader extends fx.EventDispatcher {

    constructor(fonts)
    {
        super();

        this.fonts = fonts;
    }

    getFont(name)
    {
        return this.fonts.find({name : name});
    };

    load(font)
    {
        if (typeof font == "string")
            font = this.getFont( font );
        
        if (!font || font.loading)
        {
            font.trigger("error", font);
            return;    
        }
        
        if (font.loading)
            return;

        if (font.loaded)
        {
            font.trigger("loaded", font);    
            return;
        }

        font.loadingName = font.name;
        if (font.styles != "n4")
                font.loadingName += ":" + font.styles;

        font.loading = true; 
        
        WebFont.load({
            custom: {
                families: [ font.loadingName ]
            },
            active: this._onLoaded.bind(this, font),
            inactive: this._onError.bind(this, font)
        });
    }

    disableFont(font)
    {
        
    }

    _onLoaded(font)
    {
        font.loading = false; 
        font.loaded = true;

        font.triggerDelay("loaded", font, (fx.browser.OSName != 'MacOS') ? 0 : 1000);
    }

    _onError(font)
    {
        font.loading = false; 
        font.loaded = false;

        font.trigger("error", font);
    }


});